import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { translate } from 'react-i18next';

import SimpleBox from '../../components/SimpleBox/';
import AppIcon from '../../components/AppIcon';

const styles = {
  confirmContinueActions: {
    textAlign: 'center'
  }
};

class LoginNotAllowed extends Component {

  constructor(props) {
    super(props);
    this.onOk = this.onOk.bind(this);
  }

  onOk() {
    this.props.clearSession();
    this.props.close();
  }

  render() {
    const { show, messageLocalizationKey, t } = this.props;
    const title = t(`${messageLocalizationKey}.title`);
    const message = t(`${messageLocalizationKey}.message`);
    const buttonText = t(`${messageLocalizationKey}.buttonText`);

    const simpleBox = (
      <SimpleBox >
        <div className="box-header">
          <h1>{title}</h1>
          <p>{message}</p>
          <div style={styles.confirmContinueActions} className="confirm-continue-actions">
            <Button
              className="action-btn login-reject-button"
              onClick={() => this.onOk()}
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </SimpleBox>
    );

    return (
      <Modal
        className="continue-confirmation-screen"
        show={show}
        backdrop="static"
        keyboard={false}
      >
        <Button
          bsStyle="link"
          className="close-link basic-action-link"
          onClick={() => this.onOk()}
        >
          <AppIcon iconName="CLOSE" containerClass="close-icon" />
        </Button>
        {simpleBox}
      </Modal>
    );
  }
}

LoginNotAllowed.propTypes = {
  show: PropTypes.bool.isRequired,
  messageLocalizationKey: PropTypes.string.isRequired,
  clearSession: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

LoginNotAllowed.defaultProps = {};

export default translate(['common'])(LoginNotAllowed);



// WEBPACK FOOTER //
// ./src/containers/LoginNotAllowed/LoginNotAllowed.jsx